import { ApiResponse, PaginatedApiResponse } from "@/types/api.types";
import baseApi from "./RootBaseApi";
import {
  NotificationListQueryParams,
  SingleNotification,
  NotificationListResponse,
  INotificationData,
} from "@/types/notification.types";

export const NotificationService = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getNotifications: builder.query<
      NotificationListResponse,
      NotificationListQueryParams
    >({
      query: (params) => ({
        url: "notifications",
        method: "GET",
        params: {
          ...params,
        },
      }),
      providesTags: ["Notifications"],
      keepUnusedDataFor: 60,
    }),

    getUnreadNotifications: builder.query<
      PaginatedApiResponse<INotificationData[]>,
      NotificationListQueryParams
    >({
      query: (params) => ({
        url: "notifications/unread",
        method: "GET",
        params: {
          ...params,
        },
      }),
      providesTags: ["Notifications"],
      keepUnusedDataFor: 60,
    }),

    getNotificationById: builder.query<SingleNotification, string>({
      query: (notification_id) => ({
        url: `notifications/${notification_id}`,
        method: "GET",
      }),
      providesTags: (result, error, notification_id) => [
        { type: "Notifications", id: notification_id },
      ],
      keepUnusedDataFor: 60,
    }),

    markNotificationAsRead: builder.mutation<ApiResponse<void>, string>({
      query: (notification_id) => ({
        url: `notifications/${notification_id}/read`,
        method: "PATCH",
      }),
      invalidatesTags: ["Notifications"],
    }),

    markAllNotificationsAsRead: builder.mutation<ApiResponse<void>, void>({
      query: () => ({
        url: "notifications/read-all",
        method: "PATCH",
      }),
      invalidatesTags: ["Notifications"],
    }),

    deleteAllNotifications: builder.mutation<ApiResponse<void>, void>({
      query: () => ({
        url: "notifications/all",
        method: "DELETE",
      }),
      invalidatesTags: ["Notifications"],
    }),

    deleteNotificationsByIds: builder.mutation<
      ApiResponse<null>,
      { notification_ids: string[] }
    >({
      query: (data) => ({
        url: "notifications",
        method: "DELETE",
        data,
      }),
      invalidatesTags: ["Notifications"],
    }),
  }),
});

export const {
  useGetNotificationsQuery,
  useGetUnreadNotificationsQuery,
  useGetNotificationByIdQuery,
  useMarkNotificationAsReadMutation,
  useMarkAllNotificationsAsReadMutation,
  useDeleteAllNotificationsMutation,
  useDeleteNotificationsByIdsMutation,
} = NotificationService;
